export function buildRpcUrl(apiBaseUrl: string): string {
  const rpcPath = `${apiBaseUrl.replace(/\/$/, '')}/rpc`;
  return new URL(rpcPath, window.location.origin).toString();
}
